module.exports = __webpack_public_path__ + "static/the-new-science-of-strong-materials-8b0b752daf4a05f1fb9ffd0003993334.jpg";